import React, { Component } from 'react';
import Inherit from '../../../core/inherit';
import SegmentController from './segment.controller';
import withNavigate from '../../../core/withNavigate';
import { Button } from 'antd';
import { ArrowLeft, Layers, Save } from 'lucide-react';

import { Layout, Loading, PageHeader } from '../../common';
import { CreateSegmentForm, SegmentList } from './elements';
import { SegmentViewToggle, StoreSelector, SegmentStatusBanner } from './elements/SegmentViewControls';

class ShelfSegmentList extends Inherit(SegmentController, Component) {
    state = {
        loading: true,
        clients: [],
        storeType: {},
        channel: 'moderno',
        products: [],
        defaultProducts: [],
        segment: null,
        disabled: false,
        viewMode: 'default',
        selectedStoreIds: [],
        clientStores: [],
        storeSegmentations: new Map(),
        overrideStoreIds: new Set(),
        hasOverride: false,
        canManageOverrides: false,
        deleting: false,
    };

    render() {
        const {
            storeType,
            loading,
            channel,
            clients,
            products,
            segment,
            disabled,
            viewMode,
            selectedStoreIds,
            clientStores,
            storeSegmentations,
            overrideStoreIds,
            hasOverride,
            canManageOverrides,
            deleting,
        } = this.state;

        const selectedStores = this.getSelectedStores();
        const selectionLabel =
            selectedStores.length === 1 ? selectedStores[0].name : selectedStores.length > 1 ? `${selectedStores.length} pisos de venta` : null;
        const diff = this.getOverrideDiff();
        const effectiveChannel = storeType?.channel || channel;
        const isNew = !segment && !storeType?.label;
        const isException = viewMode === 'exception';

        return (
            <Layout>
                {loading ? (
                    <Loading />
                ) : (
                    <>
                        <PageHeader
                            icon={<Layers />}
                            title={isNew ? 'Crear Segmentación' : `Segmentación de ${storeType?.label ?? segment}`}
                            description={
                                isNew ? 'Configura una nueva segmentación de productos' : 'Selecciona los productos que se auditarán en este tipo de piso'
                            }
                            actions={
                                <Button icon={<ArrowLeft />} onClick={() => this.navigateSegments()}>
                                    Segmentaciones
                                </Button>
                            }
                        />

                        <div className="space-y-4">
                            {!storeType?.label && !segment && (
                                <CreateSegmentForm
                                    segment={segment}
                                    clients={clients}
                                    channel={channel}
                                    storeType={storeType}
                                    setChannel={this.setChannel.bind(this)}
                                    onSelectType={this.selectSegmentType.bind(this)}
                                />
                            )}
                            {(storeType?.label || segment) && canManageOverrides && (
                                <SegmentViewToggle
                                    viewMode={viewMode}
                                    setViewMode={this.onViewModeChange.bind(this)}
                                    channel={effectiveChannel}
                                />
                            )}
                            {isException && effectiveChannel === 'moderno' && (
                                <StoreSelector
                                    stores={clientStores}
                                    selectedStoreIds={selectedStoreIds}
                                    onChange={this.onStoresSelect.bind(this)}
                                    onSelectAllMatching={this.selectAllMatching.bind(this)}
                                    segmentations={storeSegmentations}
                                    loading={loading}
                                    overrideStoreIds={overrideStoreIds}
                                />
                            )}
                            <SegmentStatusBanner
                                viewMode={viewMode}
                                hasOverride={hasOverride}
                                storeName={selectionLabel}
                                storeCount={selectedStores.length}
                                diff={diff}
                                onDelete={() => this.deleteOverride()}
                                deleting={deleting}
                            />
                            <SegmentList
                                products={products}
                                onToggleProduct={this.toggleProduct.bind(this)}
                                onToggleCategory={this.toggleCategory.bind(this)}
                            />
                        </div>

                        {/* Save bar */}
                        <div className="sticky bottom-4 z-10 mt-4">
                            <div className="shelf-card flex flex-col gap-3 px-5 py-3 sm:flex-row sm:items-center sm:justify-between">
                                <span className="text-sm text-surface-500">
                                    <span className="font-semibold text-surface-900 tabular-nums">{products?.length || 0}</span> productos seleccionados
                                    {isException && selectionLabel ? ` para ${selectionLabel}` : ''}
                                </span>
                                <Button
                                    type="primary"
                                    icon={<Save />}
                                    disabled={disabled || (isException && !selectedStoreIds.length)}
                                    onClick={() => this.createStoreType()}
                                    loading={disabled}>
                                    {isException
                                        ? selectedStoreIds.length > 1
                                            ? `Guardar Excepción (${selectedStoreIds.length} pisos)`
                                            : 'Guardar Excepción'
                                        : 'Guardar Segmentación'}
                                </Button>
                            </div>
                        </div>
                    </>
                )}
            </Layout>
        );
    }
}

export default withNavigate(ShelfSegmentList);
